module.exports = __webpack_public_path__ + "img/vicons.6f4208c1.svg";